const pharmacySwitch = {
  change: 'Would you like to switch your pharmacy?',
  cartSubtitle: 'Prices, availability and services may vary depending on the pharmacy.',
  cartWarning: 'For data protection reasons, the products in your shopping cart will be deleted if you switch pharmacies.',
  cartWithCouponWarning: 'For data protection reasons, the products and the stored coupon in your shopping cart will be deleted if you switch pharmacies.',
  yourPharmacy: 'Your selected pharmacy',
  newPharmacy: 'Newly selected pharmacy',
  homePharmacy: 'Home pharmacy',
  currentlySelectedPharmacy: 'Currently selected pharmacy',
  maintain: 'Maintain pharmacy',
  selectNew: 'Select new pharmacy',
  selectHome: 'Switch to home pharmacy',
}

export default pharmacySwitch
